import { Box, Button, Grid } from "@material-ui/core";
import { Form } from "@components";
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory } from "react-router";
import {
  UPDATE_FILTERS_DATA,
  UPDATE_CUSTOM_FILTER,
  CLEAR_FILTERS_DATA,
} from "../state";
import { TableContext } from "../table";
import {
  Filters,
  Search,
  filterTable,
  SystemAppNameFilters,
} from "./search-filters";
import { Actions } from "../../../screens/request/components/actions";
import { RowWrapper } from "../types";
import { createStyles, Theme, WithStyles } from "@material-ui/core/styles";
import { SystemAppNameDetail } from "../../../screens/dashboard/admin/maintenance/systemappname/detail";
import { SystemAppNameModel } from "@api/types/systemappname";
import { RequestResponse } from "@api";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onClickAdd: () => void;
}

const customFilter = (
  rowsWrappers: RowWrapper<RequestResponse>[],
  filterData: Filters
): RowWrapper<RequestResponse>[] => {
  return rowsWrappers.filter((wrapper) => {
    return filterTable(wrapper.row.data, filterData);
  });
};

export const SystemAppNameToolbar: React.FC<Props> = ({}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const { state, dispatch } = useContext(TableContext);
  const [] = useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [] = useState(false);
  const { rows } = state;

  React.useEffect(() => {
    dispatch({ type: UPDATE_CUSTOM_FILTER, customFilter });
  }, [dispatch]);

  const formFilter = Form.useManager<Filters>({
    environment: "",
    dateType: "",
    status: "",
    systemName: "",
    dateFrom: null,
    dateTo: null,
    typeOfAction: "",
    systemCategory: "",
    systemType: "",
  });

  const onSearchUpdate = useCallback(
    (term: string) => {
      setSearchValue(term);
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!openModal) {
      // clear form if modal has closed
      form.reset();
    }
  }, [openModal]);

  const form = Form.useManager<SystemAppNameModel>({
    id: 0,
    businessType: 0,
    systemCategory: 0,
    systemAppName: "",
    formName: "",
    thirdPartyFormUrl: "",
    accessDetailNote: "",
    approver: "",
    systemDesc: "",
    metadata: "",
    uamNote: "",
    assignmentTeam: "",
    isActive: false,
    isMultipleForm: false,
    isRevokeNeededForm: false,
    isSingleRequest: false,
    isRequireAttestation: false,
    isDataSensitive: false,
  });

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const isShowModal = openModal ? (
    <SystemAppNameDetail
      form={form}
      open={openModal}
      onCancel={() => setOpenModal(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New System
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by System Name"}
            defaultValue={searchValue}
          ></Search>
        </Grid>
        <Grid item container xs={12} justify="flex-end">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              dispatch({ type: CLEAR_FILTERS_DATA });
              formFilter.reset();
              setSearchValue("");
            }}
            style={{ marginLeft: "40px" }}
          >
            Reset Filter
          </Button>
        </Grid>
      </Grid>
      <SystemAppNameFilters
        open={open}
        requests={rows}
        form={formFilter}
        onApply={(filters: Filters) => {
          setOpen(false);
          dispatch({ type: UPDATE_FILTERS_DATA, filtersData: filters });
        }}
        onCancel={() => setOpen(false)}
      />
      {isShowModal}
    </Box>
  );
};
